import { parseISO } from "date-fns"
import moment from 'moment'
import { Selection } from "../enums"
import { TryParseInt } from "../Utils/parseInt"
import type {
  VehicleIdentificationDto as BaseVehicleIdentificationDto,
  ExtraEquipment,
  VehicleDto,
} from "./Step1"

export class FindVehicle implements VehicleDto, BaseVehicleIdentificationDto {
  licensePlate?: string | null
  vin?: string | null
  druh?: number | null
  palivo?: number | null
  znacka?: string | null
  zakladniModel?: string | null
  model?: string | null
  puvod?: number | null
  objem?: number | null
  vykon1?: number | null
  pocetMistSezeni?: number | null
  celkovaHmotnost?: number | null
  cisloTechnickehoPrukazu?: string | null
  firstRegistrationDate?: Date | null
  firstRegistrationDateCz?: Date | null

  constructor(vinOnline: VinOnlineVehicleDto | null) {
    if (!vinOnline) return

    this.licensePlate = vinOnline.registrationMark
    this.vin = vinOnline.vin
    this.druh = TryParseInt(vinOnline.CategoryID?.toString(), null)
    this.palivo = TryParseInt(vinOnline.FuelID?.toString(), null)
    this.znacka = vinOnline.MakeBase?.replace("CITROEN", "CITROËN")
    this.model = vinOnline.modelCarEnum ?? vinOnline.modelUniqa
    this.zakladniModel = vinOnline.ModelText?.replace("ŘADA", "RADA")
    if (vinOnline.puvodVozidla)
      this.puvod =
        vinOnline.puvodVozidla?.toLocaleLowerCase() === "o"
          ? Selection.VehicleOriginForeign
          : Selection.VehicleOriginCzech

    this.objem = vinOnline.CylinderVolume
    this.vykon1 = vinOnline.EnginePower
    this.pocetMistSezeni = vinOnline.SeatsCount
    this.celkovaHmotnost = vinOnline.TotalWeigth
    this.cisloTechnickehoPrukazu = vinOnline.TechnicalCertificateNumber

    const datumPrvniRegistraceZahranici =
      vinOnline?.FirstRegistrationDateForeign
        ? parseISO(vinOnline?.FirstRegistrationDateForeign)
        : undefined
    const datumPrvniRegistrace = vinOnline?.FirstRegistrationDate
      ? parseISO(vinOnline?.FirstRegistrationDate)
      : undefined

    const foreignFirst =
      datumPrvniRegistraceZahranici && datumPrvniRegistrace
        ? datumPrvniRegistraceZahranici < datumPrvniRegistrace
        : false

    if (!this.puvod) {
      if (foreignFirst) {
        this.puvod = Selection.VehicleOriginForeign
      } else {
        this.puvod = Selection.VehicleOriginCzech // jako výchozí hodnotu ponechat původ ČR
      }
    }

    const firstRegistrationDate =
      datumPrvniRegistraceZahranici ?? datumPrvniRegistrace

    this.firstRegistrationDate = firstRegistrationDate
    this.firstRegistrationDateCz = datumPrvniRegistrace
  }
  subCategory?: number | null | undefined
  znackaText?: string | null | undefined
  vehicleTypeDescription?: string | null | undefined
  uzemniPlatnost?: number | null | undefined
  vykon2?: number | null | undefined
  isInProduction?: boolean | null | undefined
  mileage?: number | null | undefined
  cisloOrv?: string | null | undefined
  usage?: number | null | undefined
  yearKm?: string | null | undefined
  serialNumber?: string | null | undefined
  purchaseDate?: Date | null | undefined
  warrantyStartDate?: Date | null | undefined
  warrantyKmLimit?: string | null | undefined
  warrantyTermLimit?: string | null | undefined
  manufacturerWarrantyType?: number | null | undefined
  vehicleLeasing: boolean | null = null
  smluvniServis: boolean | null = null
  prefLikvidace: boolean | null = null
  autorizovanyServis: boolean | null = null
  foreignRepairShop: boolean | null = null
  equipment: number[] | null = null
  extraEquipments: ExtraEquipment[] | null = null
  security: number[] | null = null
  vehicleGaraged?: boolean | undefined

  // uzemniPlatnost?: string | undefined
  // vykon2?: number | null | undefined
  //mileage?: number | null | undefined
  // usage?: number | undefined
  // yearKm?: string | undefined
  // purchaseDate?: Date | null | undefined
  // warrantyStartDate?: Date | null | undefined
  // warrantyKmLimit?: string | undefined
  // warrantyTermLimit?: string | undefined
  // extraEquipmentValue?: string | undefined
  // extraEquipmentDescription?: string | undefined
}

export interface VinOnlineVehicleDto {
  error?: string
  registrationMark?: string
  vin?: string
  MakeBase?: string
  FuelID?: number
  TotalWeigth?: number
  FirstRegistrationDateString?: string
  ModelText?: string
  CylinderVolume?: number
  SeatsCount?: number
  EnginePower?: number
  CategoryID?: number
  druh?: string
  TechnicalCertificateNumber?: string
  // cztp?: string
  FirstRegistrationDate?: string
  FirstRegistrationDateForeign?: string
  druhPaliva?: string
  // druhVozidlaIIZTP?: string
  // druhVozidlaZTP?: string
  // hmotnostJizdniSoupravy?: number
  // kategorie?: string
  // pocetMistLezeni?: number
  // pocetMistStani?: number
  // pohotovostniHmotnos?: string
  puvodVozidla?: string
  // rokVyroby?: number
  vysledekKontrolyVin?: boolean
  vysledekKontrolyVinTextove?: string
  // ztpPoznamka?: string
  Generace?: string
  // model_I?: string
  Verze?: string
  // zeme_I?: string
  modelMerged?: string
  modelHint?: string
  modelCarEnum?: string
  makeUniqa?: string
  modelUniqa?: string
}

export type VehiclesIdentificationDto = {
  vehicles?: OneVehicleIdentificationDto[]
  error?: string
}

export type OneVehicleIdentificationDto = {
  id?: string
  description?: string
  vin?: string
  registrationMark?: string
  typeDescription?: string
  accessoriesOptionalSelected?: string
  saleFrom?: Date
  saleTo?: Date
  versionSpecificationChanged?: string | null
  registrationDate?: Date | null
  price?: number
  priceWithEquipment?: number
  engine?: string
  fuel?: string
  transmission?: string
  consumption?: string
  brand?: string
  model?: string
  generation?: string
  versionName?: string
  pdfLink?: string
}

export type VehicleValuationDto = {
  baseVehicleNewPrice: number
  vehicleNewPrice: number
  baseVehicleMarketPrice: number
  vehicleMarketPrice: number
  vehicleMarketPriceWithTax: number
  error?: string
}

export type GetCebiGlassRequest = {
  licencePlate?: string | null
  vin?: string | null
}
export type CebiGlassInfoDto = {
  vin?: string
  registrationMark?: string
  PriceOriginal?: number
  PriceSecondaryManufacturing?: number
  PriceOriginalNoVat?: number
  PriceSecondaryManufacturingNoVat?: number
  error?: string
}

export const getVehicleInformationItems = (vinOnline: VinOnlineVehicleDto) => {
  const result = [
    { label: 'Registrační značka (SPZ)', value: vinOnline.registrationMark },
    { label: 'Číslo TP', value: vinOnline.TechnicalCertificateNumber },
    { label: 'VIN', value: vinOnline.vin },
    { label: 'Značka', value: vinOnline.MakeBase },
    { label: 'Model', value: vinOnline.modelMerged },
    { label: 'Generace', value: vinOnline.Generace },
    { label: 'Verze', value: vinOnline.Verze },
    { label: 'Míst k sezení', value: vinOnline.SeatsCount },
    { label: 'Druh vozidla', value: vinOnline.druh },
    { label: 'Druh paliva', value: vinOnline.druhPaliva },
    { label: 'Celková hmotnost', value: vinOnline.TotalWeigth },
    { label: 'Výkon', value: vinOnline.EnginePower },
    { label: 'Objem', value: vinOnline.CylinderVolume },
  ]



  let puvod: typeof Selection.VehicleOriginForeign | typeof Selection.VehicleOriginCzech | undefined = undefined
  if (vinOnline.puvodVozidla) {
    const puvod = vinOnline.puvodVozidla?.toLocaleLowerCase() === "o" ? Selection.VehicleOriginForeign : Selection.VehicleOriginCzech
    result.push({ label: 'Původ', value: puvod == Selection.VehicleOriginForeign ? "v zahraničí" : "v ČR" })
  }

  const datumPrvniRegistraceZahranici = vinOnline?.FirstRegistrationDateForeign ? parseISO(vinOnline?.FirstRegistrationDateForeign) : undefined
  const datumPrvniRegistrace = vinOnline?.FirstRegistrationDate ? parseISO(vinOnline?.FirstRegistrationDate) : undefined

  const foreignFirst = datumPrvniRegistraceZahranici && datumPrvniRegistrace
    ? datumPrvniRegistraceZahranici < datumPrvniRegistrace
    : false

  if (!puvod && foreignFirst)
    puvod = Selection.VehicleOriginForeign

  const firstRegistrationDate = datumPrvniRegistraceZahranici ?? datumPrvniRegistrace
  if (firstRegistrationDate)
    result.push({
      label: 'První registrace',
      value: puvod == Selection.VehicleOriginForeign ? moment(vinOnline.FirstRegistrationDateForeign).format('D. M. YYYY') : vinOnline.FirstRegistrationDateString
    })

  if (datumPrvniRegistrace)
    result.push({
      label: 'První registrace v ČR',
      value: puvod == Selection.VehicleOriginForeign ? moment(vinOnline.FirstRegistrationDate).format('D. M. YYYY') : undefined
    })

  return result
}